// index.css sets `overflow-x: hidden` plus `height: 100%` on html/body. Per the
// CSS spec a non-visible overflow on one axis makes the other axis `auto`, so
// the real scroll container ends up being <body> rather than the viewport, and
// a plain window.scrollTo() is a no-op. Reset every candidate scroller.
export function scrollWindowToTop(behavior = 'auto') {
  scrollWindowTo(0, 0, behavior);
}

export function getWindowScrollPosition() {
  return {
    x: Math.max(window.scrollX || 0, document.documentElement?.scrollLeft || 0, document.body?.scrollLeft || 0),
    y: Math.max(window.scrollY || 0, document.documentElement?.scrollTop || 0, document.body?.scrollTop || 0),
  };
}

export function scrollWindowTo(x = 0, y = 0, behavior = 'auto') {
  const opts = { top: y, left: x, behavior };
  window.scrollTo(opts);
  document.documentElement?.scrollTo?.(opts);
  document.body?.scrollTo?.(opts);
}

export default scrollWindowToTop;
